import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {PillStatus, StatusPillType, StatusPillVariant} from "@/components/statusPill/StatusPill.types.ts";
import {ComponentStatusValue} from "@/lib/types/statuspages.ts";

const ComponentStatusPillMap: Record<ComponentStatusValue, PillStatus> = {
  [ComponentStatusValue.OPERATIONAL]: PillStatus.OPERATIONAL,
  [ComponentStatusValue.MAJOR_OUTAGE]: PillStatus.OUTAGE,
  [ComponentStatusValue.PARTIAL_OUTAGE]: PillStatus.PARTIAL_OUTAGE,
  [ComponentStatusValue.DEGRADED_PERFORMANCE]: PillStatus.DEGRADED_PERFORMANCE,
  [ComponentStatusValue.UNDER_MAINTENANCE]: PillStatus.MAINTENANCE,
  [ComponentStatusValue.NO_CHANGE]: PillStatus.NO_CHANGE,
  [ComponentStatusValue.NOTIFICATION]: PillStatus.NOTIFICATION,
};

interface ComponentStatusProps {
  className?: string;
  status: ComponentStatusValue;
  variant?: StatusPillVariant;
  type?: StatusPillType;
  disabled?: boolean;
}

const ComponentStatusIcon = ({
  status,
  className,
  type = "checks",
  variant = "textAndIcon",
  disabled,
}: ComponentStatusProps) => {
  return (
    <StatusPill
      type={type}
      status={ComponentStatusPillMap[status]}
      variant={variant}
      className={className}
      disabled={disabled}
    />
  );
};

export default ComponentStatusIcon;
